import { AxiosError, AxiosRequestConfig } from "axios";
import { BaseQueryFn } from "@reduxjs/toolkit/query";

import axios from "utils/axios";

type BaseQuery = {
  url: string;
  method?: AxiosRequestConfig<any>["method"];
  data?: AxiosRequestConfig<any>["data"];
  params?: AxiosRequestConfig<any>["params"];
  headers?: AxiosRequestConfig<any>["headers"];
  responseType?: AxiosRequestConfig<any>["responseType"];
};
const baseQuery: BaseQueryFn<BaseQuery, unknown, unknown> = async ({
  url,
  method = "get",
  data,
  params,
  headers,
  responseType,
}) => {
  try {
    const result = await axios({
      url,
      method,
      data,
      params,
      headers,
      responseType,
    });

    if (result.data.error) {
      throw new Error(result.data.error);
    }

    return { data: result.data };
  } catch (axiosError) {
    let err = axiosError as AxiosError;

    const responseData = err.response?.data;
    const data = typeof responseData === "object" && responseData !== null
      ? {
          ...(responseData as Record<string, unknown>),
          message: (responseData as any)?.message || err.message,
        }
      : {
          message: err.message,
        };
    return {
      error: {
        status: err.response?.status || 500,
        data,
      },
    };
  }
};

export default baseQuery;
